import { Card, Col, Container, Row } from 'react-bootstrap'
import { useEffect } from 'react'
import AOS from 'aos'
import './Industrials.css'


const Industrials = () => {
    useEffect(() => {
        AOS.init({
            duration : 1500
        })
        AOS.refresh()
    }, [])

    return (
        <main className='industrials'>
            <Container>
                <Row xs={1}>
                    <Col className='my-5'>
                        <Row className='justify-content-center align-items-center'>
                            <Col sm={'12'} md={'6'}>
                                <img data-aos='fade-down' src='./img/img3.jpg' className='img-fluid' alt='Foto 1' />
                            </Col>
                            <Col sm={'12'} md={'6'}>
                                <Card className='card1' data-aos='fade-left'>
                                    <p>
                                        Especialistas en Frío Industrial implementado en el Sector Secundario. 
                                        Ofrecemos la mejor solución desde la fabricación de Equipos, hasta el 
                                        desarrollo documental para nuestros clientes.
                                    </p>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default Industrials